module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABBElEQVR4Ac0RQ0OEQbT/tt69Ztc12za/bybbtm27U1jb9t56nbN7M/Ps8foV4GDeO+8zAQySy0KPDBvxmCQXxNcCWIgb2S0O6RBFD0oTRmShHaKILhGL5D4fQCe4mVPyxm1t4og0eVRWMKfE65qmbW36hBxMzwRAA10H+upVNbGmHjo1rN9aQcyfVXYf6MH0fEvg0byjvZY5Ib3M6Bk4NiSPyfqO9OxnW6IRXLyhad3V5UwrKpZV92p3264OWgIl7aWWfJoF01emlh0txJQsqnoPDbPXZt9mwYstMQhuQKuQWNOkTchTxmS1a+rANiEoX/sHSEat5YITXGCYz//DR3/6n8EDU7UfrBJpiEEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_united-nations.png
// module id = 1324
// module chunks = 0